import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 账户类型
 */
class AccountType extends UltMeta {
    PLATFORM = new Meta(1, "平台账户");
    SUPPLIER = new Meta(2, "供应商账户");
}

export const ACCOUNT_TYPE = new AccountType();

class PlatBankAccountState extends UltMeta {
    DIASABLE = new Meta(0, "禁用");
    ENABLED = new Meta(1, "启用");
}

export const PLAT_BANK_ACCOUNT_STATE = new PlatBankAccountState();
